import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageFR() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: Analyse Relationnelle IA | Détectez les schémas Toxiques et le Gaslighting" description="Découvrez si votre ex est le problème. Téléchargez vos discussions sur l'IA de ToxicDetector pour une analyse instantanée et confidentielle de la manipulation, du gaslighting et des signaux d'alarme. Démarrez l'analyse gratuite aujourd'hui." keywords="analyse relationnelle IA, détecter schémas toxiques, détecteur de gaslighting, ex toxique, vérificateur de manipulation, toxicité relationnelle, scanner de texte IA" canonical="https://toxicdetector.com/fr" language="fr" alternateUrls={alternateUrls} data-id="element-5764" data-mp="2j9ri0f6p2ufs" />
      <GoogleTranslateWidget data-id="element-5765" data-mp="18qpr9b0f2ayc" />
      <PromoBanner data-id="element-5766" data-mp="18na9u1j9sptr" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-5767" data-mp="13qbfpizlwivk">
        <Header data-id="element-5768" data-mp="yr78gxw8sv7v" />
        <main data-id="element-5769" data-mp="yrqhtq7tubaa">
          <HeroSection h1Override={<>
                Votre Cerveau Vous{' '}
                <span className="relative inline-block" data-id="element-5771" data-mp="3ohbzhz5hrigy">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-5772" data-mp="3jhpl3mdxfw6k">
                    Ment
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-5773" data-mp="39bemnlcnez1u" />
                </span>
                {'. '}
                <br data-id="element-5774" data-mp="3ja463ik70rk7" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-5775" data-mp="3j9m21zrah91q">
                  Pas Notre IA.
                </span>
              </>} data-id="element-5770" data-mp="yq5lpw5v6kab" />
          <TrustSection data-id="element-5776" data-mp="3s3qycyp6zcon" />
          <FeaturesSection data-id="element-5777" data-mp="xph28emvmuk" />
          <GuaranteesSection data-id="element-5778" data-mp="wwjny1ke9p3" />
          <ToolsSection data-id="element-5779" data-mp="w4lcfgl1xv4" />
          <ComparisonSection data-id="element-5780" data-mp="ziq1ucpyj5q" />
          <PricingSection data-id="element-5781" data-mp="5w95qgkm3cqm" />
          <FAQSection data-id="element-5782" data-mp="5y3r1vzsp6v8" />
          <CTASection data-id="element-5783" data-mp="5xk606eum2cz" />
        </main>
        <Footer data-id="element-5784" data-mp="avlpgsg6s3oz" />
      </div>
    </>;
}